import React from 'react';
import Recognize from './components/recognize/Recognize';

export const routes = [
    {
        title: 'RecognitionNow',
        pattern: '/',
        render: ( props ) => (
            <Recognize { ...props } />
        ),
        requiresAuth: false
    }
];

const Bundle = ( Component ) => (
    // eslint-disable-next-line react/display-name
    ( props ) => (
        <Component { ...props } />
    )
);

export const getMiddleware = () => {
    return [
        // Load Bundles
        ( action, nextRoute, prevRoute ) => {
            const { match } = nextRoute;

            if (
                match &&
                    !match.render &&
                    typeof match.load === 'function'
            ) {
                match.load( ( asyncModule ) => {
                    match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
                    action.ok();
                } );
            } else {
                action.ok();
            }
        }
    ];
};
